import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useClaimQuery } from '../../../api/gql';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';
import { EndRemindingModule } from '../../../modules/dialogs/end-reminding';

export const ClaimEndRemindingPage = () => {
  const { invoiceId } = useParams();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  if (!invoiceId) {
    throw new Error('Invoice id is required');
  }

  return (
    <EndRemindingModule
      invoiceId={invoiceId}
      transNs={'page-claim-detail'}
      keyPrefix={'endReminding.dialog'}
      onSuccess={({ endReminding }) => {
        queryClient.setQueryData(useClaimQuery.getKey({ id: endReminding.id }), {
          invoice: { ...endReminding },
        });
        safeNavigate(`/claim/${endReminding.id}`);
      }}
    />
  );
};
